<template>
  <div>
    <Header
      class="yh-header"
      active="/product"
      show-sub
      :product-value="productValue"
    >
      <template #left>
        <ImageAndName
          :image="util.getImageUrl(util.getHead(util.string2Array(info.images)), '48x48')"
          :name="info.name"
          :code="info.code"
        />
      </template>
      <template #right>
        <Feedback
          target-name="商品百科"
          :target-id="$route.params.id"
        />
        <Favourite
          target-name="product"
          :target-id="$route.params.id"
          :purchase-level="0"
        />
      </template>
    </Header>
    <div style="height: 130px" />
    <ProductFooBestDetail
      class="yh-main"
      :info="info"
    />
    <div style="min-height: 70px" />
  </div>
</template>

<script>
import Header from '@/components/Header'
import ProductFooBestDetail from './Components/ProductFooBestDetail.vue'
import Favourite from '@/components/Favourite.vue'
import ImageAndName from '@/components/ImageAndName.vue'
import Feedback from '@/components/Feedback'

export default {
  name: 'ProductBaike',
  components: {
    Header,
    ProductFooBestDetail,
    Favourite,
    ImageAndName,
    Feedback
  },
  data() {
    return {
      productValue: this.util.getVariantSession('tagId')
    }
  },
  computed: {
    info() {
      return this.$store.state.product.productFoodWiki.get
    }
  },
  async created() {
    await this.$store.dispatch('productBasePage', {
      packageName: 'product',
      className: 'productFoodWiki',
      methodName: 'get',
      params: {
        id: this.$route.params.id
      }
    })
  }
}
</script>

<style lang="less" scoped>
.el-header {
  box-shadow: 0px 0px 18px 0px rgba(0, 0, 0, 0.06);
}
.container {
  width: 1140px;
  margin: 5px auto;
}
.el-breadcrumb {
  width: 1100px;
  margin: 0 auto;
  padding: 20px 0;
  border-bottom: 1px solid #eee;
}
.el-main {
  position: relative;
  padding-top: 0;
}
// .fav {
//   position: absolute;
//   right: 20px;
//   top: 20px;
// }
</style>
